import { IconButton } from "@mui/material";
import { styled } from "@mui/styles";
import { executeGetSnapshotRequest } from "api/common/detections.api";
import StatusCodes from "enums/status-code.enums";
import React, { useEffect, useRef, useState } from "react";
import { GrClose } from "react-icons/gr";
import { useNavigate, useSearchParams } from "react-router-dom";

const NOT_FOUND_URL = "/page-not-found";
const FORBIDDEN_URL = "/forbidden";

const Img = styled("img")(() => ({
    height: "100%",
    width: "100%",
}));

const ImagePreview = () => {
    const [searchParams] = useSearchParams();
    const [src, setSrc] = useState<string>();
    const snapshotAbortControllerRef = useRef<AbortController | null>(null);
    const { objectId, incidentId, snapshotKey } = Object.fromEntries([...searchParams]) || {};
    const navigate = useNavigate();

    async function getSnapshot() {
        try {
            snapshotAbortControllerRef.current = new AbortController();
            const { signal } = snapshotAbortControllerRef.current;
            const requestData: Record<string, unknown> = { incidentId };
            if (snapshotKey) {
                requestData.multi = true;
            }
            const response = await executeGetSnapshotRequest(requestData, { signal, disableNotification: true });

            if (snapshotKey) {
                if (!response || typeof response === "string") {
                    navigate(NOT_FOUND_URL, { replace: true });
                    return;
                }
                const url = response[snapshotKey];
                if (!url) {
                    navigate(NOT_FOUND_URL, { replace: true });
                    return;
                }
                setSrc(url);
            } else if (response !== undefined && typeof response === "string") {
                setSrc(response);
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err: Error | any) {
            if (err?.response?.status === StatusCodes.FORBIDDEN) {
                navigate(FORBIDDEN_URL, { replace: true });
                return;
            }
            navigate(NOT_FOUND_URL, { replace: true });
            console.error(err);
        }
    }
    const closeTab = () => {
        window.close();
    };

    useEffect(() => {
        getSnapshot();
    }, [objectId]);

    return (
        <div>
            <IconButton
                edge="start"
                color="inherit"
                onClick={closeTab}
                sx={{
                    position: "absolute",
                    width: "38px",
                    height: "38px",
                    right: "15px",
                    top: "10px",
                    backgroundColor: "rgb(150, 149, 149)",
                }}
            >
                <GrClose fontSize={40} fontWeight={600} />
            </IconButton>
            <Img src={src} />
        </div>
    );
};

export default ImagePreview;
